module.exports = __webpack_public_path__ + "static/img/done_icon.a89c89f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/done_icon.png
// module id = I88G
// module chunks = 167